// ==============================|| THEME CONFIG  ||============================== //

const config = {
  defaultPath: "/dashboard/default",
  fontFamily: `'Public Sans', sans-serif`,
  i18n: "en",
  miniDrawer: false,
  container: true,
  mode: "light",
  presetColor: "default",
  themeDirection: "ltr",
}
export const modalStyle = {
  position: "absolute",
  display: "block",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  height: "70svh",
  overflow: "scroll",
  bgcolor: "background.paper",
  // boxShadow: 24,
  // p: 5,
}

export default config
export const drawerWidth = "300px"
export const headerHeight = "5rem"

export const twitterColor = "#1DA1F2"
export const facebookColor = "#3b5998"
export const linkedInColor = "#0e76a8"
